import { Button, Modal, Text } from "@simplybusiness/mobius";
import { useState, useRef } from "react";
import type { WithInterventionProps } from "../../types";
import { getCallOrChatVariant, getInterventionTitle, getTrade } from "./utils";

export type QCPInactivityInterventionProps = {
  trade: string;
  vertical: string;
};

type ModalInterventionProps =
  WithInterventionProps<QCPInactivityInterventionProps>;

export const QCPInactivityIntervention = (props: ModalInterventionProps) => {
  const { fireEvent } = props;
  const displayTrade = getTrade(props.trade);
  const vertical = props.vertical;
  const { component_names } = props.data || {};
  const componentType = component_names?.[0] || "";
  const [isOpen, setIsOpen] = useState(true);
  const parseComponentType = (componentType: string) => {
    const parts = componentType.split("-");
    const interventionVersion = parts[3];
    const contactVariant = parts[4];
    return { interventionVersion, contactVariant };
  };
  const { interventionVersion, contactVariant } =
    parseComponentType(componentType);

  const interventionSubtext =
    interventionVersion === "generic"
      ? "You can get personalized help from our small business specialists."
      : `You can get personalized help from our ${displayTrade} specialists.`;

  const title = getInterventionTitle(interventionVersion);
  const variant = getCallOrChatVariant(
    contactVariant,
    vertical,
    setIsOpen,
    fireEvent,
  );
  const hasFiredEventRef = useRef(false);

  return contactVariant === "control" ? (
    <div></div>
  ) : (
    <Modal
      className="qcp-inactivity-intervention__qcp-intervention-modal"
      isOpen={isOpen}
      onOpen={() => {
        if (hasFiredEventRef.current) return;
        fireEvent?.("qcp_modal_shown");
        hasFiredEventRef.current = true;
      }}
      animation="fade"
    >
      <div className="qcp-inactivity-intervention__qcp-content-container">
        <div className="qcp-inactivity-intervention__qcp-text-container">
          <Text elementType="h2">{title}</Text>
          <Text
            className="qcp-inactivity-intervention__qcp-subtext"
            elementType="p"
          >
            {interventionSubtext}
          </Text>
          {variant}
          <Button
            data-testid="qcp-inactivity-back-button"
            className={`qcp-inactivity-intervention__button qcp-inactivity-intervention__bottom-button ${
              contactVariant === "chat"
                ? "qcp-inactivity-intervention__full-width-button"
                : ""
            }`}
            variant="secondary"
            size="sm"
            onClick={() => {
              setIsOpen(false);
              fireEvent?.("qcp_modal_closed");
            }}
          >
            Back to Quotes
          </Button>
        </div>
      </div>
      <div className="qcp-inactivity-intervention__qcp-image"></div>
    </Modal>
  );
};
